'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.multiOptions = multiOptions;
exports.getSelect = getSelect;
exports.nfcall = nfcall;

var _feathersQueryFilters = require('feathers-query-filters');

var _feathersQueryFilters2 = _interopRequireDefault(_feathersQueryFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function multiOptions(id, idField, params) {
  var query = (0, _feathersQueryFilters2.default)(params.query || {}).query;
  var options = Object.assign({ multi: true }, params.nedb || params.options);

  if (id !== null) {
    options.multi = false;
    query[idField] = id;
  }

  return { query: query, options: options };
}

function getSelect(select) {
  if (Array.isArray(select)) {
    var result = {};
    select.forEach(function (name) {
      return result[name] = 1;
    });
    return result;
  }

  return select;
}

function nfcall(ctx, method) {
  var args = Array.prototype.slice.call(arguments, 2);

  return new Promise(function (resolve, reject) {
    args.push(function (error, data) {
      if (error) {
        return reject(error);
      }

      resolve(data);
    });

    ctx[method].apply(ctx, args);
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/feathers-nedb/lib/utils.js
// module id = 816
// module chunks = 0